import { Button, withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { Translation } from 'react-i18next'
import {
  Field,
  Form,
  useForm,
  useWatch,
  WatchField,
  useFieldArray,
  setFieldValue
} from '../../form'
import { allowanceValidate } from '../../containers/validate'
import classNames from 'classnames'
import CountrySelectField from '../common/countrySelectField'
import mobileView from '../../utils/mobile.utils'
import IconButton from '@material-ui/core/IconButton'
import FontAwesome from 'react-fontawesome'
import { DayAllowance, payMileage } from '../expenses/newAllowance.component'
import SummaryTableComponent from '../expenses/summaryTable.component'
import Consent from '../expenses/consent.component'
import ModalComponent from '../layout/modal.component'
import { useDispatch } from 'react-redux'

const poweredByGoogle = '../../images/poweredByGoogle.png'

class AddAllowanceComponent extends React.Component {
  componentDidMount() {
    this.props.loadAllowanceCost(new Date().getFullYear())
  }

  render() {
    return <AddAllowanceForm {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  switch: {
    position: 'relative',
    marginLeft: '10px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#000000'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  textField2: {
    marginTop: theme.spacing(3)
  },
  resize: {
    fontSize: '14px'
  },
  select: {
    // lineHeight: '1.5',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  },
  checkbox2: {
    marginTop: theme.spacing(2),
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#808080'
  },
  checkbox1: {
    marginTop: theme.spacing(2),
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  },
  checkbox: {
    // marginTop: theme.spacing(2),
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  },
  kilometerAllowanceForm: {
    marginLeft: '-15px',
    display: 'flex',
    whiteSpace: 'nowrap',
    gap: '18px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '100%',
      gap: '0px'
    }
  },
  kilometerAllowanceField: {
    flex: 1,
    minWidth: '0',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  additionalCheckbox: {
    marginTop: theme.spacing(1),
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#808080',
    padding: '0 10px'
  },
  table: {
    minWidth: 200
  },
  passengerBtn: {
    margin: '20px 0',
    float: 'right'
  },
  dailyFoodAllowanceForm: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '18px',
    marginLeft: mobileView ? '-14px' : '-4px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '100%'
    }
  },
  foodAllowanceField: {
    flex: 1,
    minWidth: '0',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0
    }
  },
  googleLogo: {
    margin: '16px 15px 0px 0px',
    maxHeight: '20px'
  }
})

const mileageDefaults = {
  distance: '',
  license_plate: '',
  vehicle_type: 'default_vehicle_type',
  allowancePassenger: [],
  forest_trail: false,
  heavy_load: false,
  working_dog: false,
  additional_vehicle_cost: 'default_additional_vehicle_cost'
}

export const defaultValues = {
  destination: '',
  country: '1',
  start_date: new Date(),
  end_date: new Date(),
  start_time: new Date(),
  end_time: new Date(),
  allowanceInputRow: [
    {
      route: ''
    },
    {
      route: ''
    }
  ],
  mileage_allowance: false,
  ...mileageDefaults,
  day_allowance: false,
  full_time_allowance: 0,
  part_time_allowance: 0,
  meal_allowance: 0,
  consent: false,
  decisionSelect: '',
  startPlace: [
    {
      route: ''
    }
  ],
  endPlace: [
    {
      route: ''
    }
  ]
}

const AddAllowanceForm = ({
  classes,
  invoiceFormControl,
  countryList,
  resetForm,
  loadAllowanceCost,
  calculateDistance,
  vehicleTypeItems,
  vehicleAdditionalItems,
  clearAdditionalVehicleInfo,
  allowanceCost,
  enableAllowanceBackBtn,
  getValuesInvoiceForm,
  saveAllowance,
  disableAllowanceBackBtn
}) => {
  const dispatch = useDispatch()

  const form = useForm({
    name: 'allowance',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: allowanceValidate,
    mode: 'onChange'
  })
  const { control, setValue, getValues } = form

  const [isDialogOpen, setIsDialogOpen] = React.useState(false)

  function onSubmit(values) {
    let formValues = { ...values }
    if (!formValues.day_allowance) {
      formValues.full_time_allowance = 0
      formValues.part_time_allowance = 0
      formValues.meal_allowance = 0
    }
    if (!formValues.mileage_allowance) {
      formValues = { ...formValues, ...mileageDefaults }
    }
    saveAllowance(formValues)
    setIsDialogOpen(false)
  }

  const groupInvoiceCheck = useWatch({
    fields: 'groupInvoice',
    control: invoiceFormControl
  })
  const addCostCheck = useWatch({
    fields: 'addCost',
    control: invoiceFormControl
  })

  const handleCheckAddAllowance = (e) => {
    const isChecked = e.target.checked
    if (isChecked) {
      setIsDialogOpen(true)
      enableAllowanceBackBtn(getValuesInvoiceForm())
    } else if (!isChecked) {
      setIsDialogOpen(false)
      resetForm('allowance')
      disableAllowanceBackBtn()
    }
  }

  const handleCloseDialog = () => {
    dispatch(
      setFieldValue('invoice', {
        field: 'addAllowance',
        value: false
      })
    )
    setIsDialogOpen(false)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="row">
            <div className="dashboard-content-header">
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <div
                  className="panel panel-default"
                  style={{
                    border: '1px solid #AEE0E7',
                    padding: '5px',
                    borderRadius: '10px'
                  }}
                >
                  <div>
                    <Field
                      name="addAllowance"
                      label={t('invoice.button9')}
                      inputType="switch"
                      control={invoiceFormControl}
                      className={classes.switch}
                      onChange={(e) => handleCheckAddAllowance(e)}
                      disabled={
                        groupInvoiceCheck.groupInvoice || addCostCheck.addCost
                          ? true
                          : false
                      }
                    />
                  </div>
                  <ModalComponent
                    open={isDialogOpen}
                    onClose={handleCloseDialog}
                    content={
                      <div>
                        <div
                          className="central-text"
                          style={{
                            fontWeight: 1000,
                            fontSize: '20px',
                            padding: '8px'
                          }}
                        >
                          {t('newAllowComponent.h1b')}
                        </div>

                        {/*Add allowance form*/}
                        <Form {...form}>
                          <div
                            className="panel-title-cost"
                            style={{ padding: '8px', overflowX: 'auto' }}
                          >
                            {t('newAllowComponent.h3b')}
                          </div>
                          <div className="row">
                            <div>
                              <div
                                className="col-xs-12 col-sm-12 col-md-5 col-lg-5"
                                style={{
                                  paddingRight: mobileView ? '15px' : 0
                                }}
                              >
                                <div
                                  className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                  style={{
                                    paddingRight: mobileView ? '15px' : 0
                                  }}
                                >
                                  <Field
                                    name="destination"
                                    inputType="textfield"
                                    control={control}
                                    label={t('newAllowComponent.label2')}
                                    className={classNames(
                                      classes.textField,
                                      classes.resize
                                    )}
                                  />
                                </div>
                                <div
                                  className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                  style={{
                                    paddingRight: mobileView ? '15px' : 0
                                  }}
                                >
                                  <CountrySelectField
                                    classes={classes}
                                    countryList={countryList}
                                    control={control}
                                  />
                                </div>
                              </div>
                              <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">
                                <div
                                  className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                                  style={{
                                    padding: mobileView ? '0px 15px' : 0
                                  }}
                                >
                                  <WatchField
                                    control={control}
                                    fields="end_date"
                                  >
                                    {(watch) => (
                                      <Field
                                        name="start_date"
                                        inputType="datepicker"
                                        control={control}
                                        label={t('newAllowComponent.label4')}
                                        className={classNames(
                                          classes.textField,
                                          classes.resize
                                        )}
                                        maxDate={watch.end_date}
                                        onChange={(e) => {
                                          loadAllowanceCost(
                                            new Date(e).getFullYear()
                                          )
                                        }}
                                        labelStyle={{
                                          fontSize: '14px',
                                          letterSpacing: '-0.5px',
                                          marginTop: '-12px'
                                        }}
                                      />
                                    )}
                                  </WatchField>
                                </div>
                                <div
                                  className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                                  // style={{ padding: 0 }}
                                >
                                  <Field
                                    name="start_time"
                                    inputType="timepicker"
                                    control={control}
                                    label={t('newAllowComponent.label5')}
                                    className={classNames(
                                      classes.textField,
                                      classes.resize
                                    )}
                                  />
                                </div>
                                <div
                                  className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                                  style={{
                                    padding: mobileView ? '0px 15px' : 0
                                  }}
                                >
                                  <WatchField
                                    control={control}
                                    fields="start_date"
                                  >
                                    {(watch) => (
                                      <Field
                                        name="end_date"
                                        inputType="datepicker"
                                        control={control}
                                        label={t('newAllowComponent.label6')}
                                        className={classNames(
                                          classes.textField,
                                          classes.resize
                                        )}
                                        minDate={watch.start_date}
                                        labelStyle={{
                                          fontSize: '14px',
                                          letterSpacing: '-0.5px',
                                          marginTop: '-12px'
                                        }}
                                      />
                                    )}
                                  </WatchField>
                                </div>
                                <div
                                  className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                                  // style={{ padding: 0 }}
                                >
                                  <Field
                                    name="end_time"
                                    inputType="timepicker"
                                    control={control}
                                    label={t('newAllowComponent.label7')}
                                    className={classNames(
                                      classes.textField,
                                      classes.resize
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {mobileView ? (
                            <hr style={{ marginBottom: 0 }} />
                          ) : null}
                          {/* <div className="row"> */}
                          <AllowanceRoutes
                            classes={classes}
                            control={control}
                            getValues={getValues}
                            calculateDistance={calculateDistance}
                          />
                          {/* </div> */}
                          <div
                            className="panel-title-cost"
                            style={{ padding: '8px', overflowX: 'auto' }}
                          >
                            {' '}
                            {t('newAllowComponent.h3c')}
                          </div>
                          <div className="row" style={{ padding: '0px 15px' }}>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              <Field
                                name="mileage_allowance"
                                label={t('newAllowComponent.label8')}
                                inputType="checkbox"
                                control={control}
                                className={classes.checkbox2}
                                // onChange={clearMileageErrors}
                              />
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: mobileView ? 'column' : 'row'
                                }}
                              >
                                {payMileage(
                                  classes,
                                  vehicleTypeItems,
                                  vehicleAdditionalItems,
                                  clearAdditionalVehicleInfo,
                                  control
                                )}
                              </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              <Field
                                name="day_allowance"
                                label={t('newAllowComponent.label9')}
                                inputType="checkbox"
                                control={control}
                                className={classes.checkbox2}
                                // onChange={clearDayAllowanceErrors}
                              />
                              <div
                                style={{
                                  display: mobileView ? 'flex' : '',
                                  flexDirection: mobileView ? 'column' : ''
                                }}
                              >
                                <DayAllowance
                                  classes={classes}
                                  control={control}
                                  setValue={setValue}
                                />
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <SummaryTableComponent
                              allowanceCost={allowanceCost}
                              control={control}
                            />
                          </div>
                          <div style={{ padding: '8px' }}>
                            <WatchField
                              control={control}
                              fields="decisionSelect"
                            >
                              {(watch) => (
                                <>
                                  <Field
                                    name="decisionSelect"
                                    inputType="checkbox-for-strings"
                                    className={classes.checkbox1}
                                    control={control}
                                    label={t('decisionDialog.addToInvoice3')}
                                    // onChange={onChange}
                                    stringValue="add_to_invoice"
                                  />
                                  <div>
                                    <p
                                      className={
                                        watch.decisionSelect ===
                                        'add_to_invoice'
                                          ? 'visible'
                                          : 'invisible'
                                      }
                                    >
                                      {t('decisionDialog.addToInvoiceDesc1')}
                                    </p>
                                  </div>
                                </>
                              )}
                            </WatchField>
                            <div style={{ marginLeft: '-21px' }}>
                              <Consent
                                classes={classes}
                                control={control}
                                invoiceItemType="allowance"
                              />
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: '15px', margin: 0 }}
                          >
                            <div className="pull-right">
                              <Button
                                variant="contained"
                                className={classes.button1}
                                type="submit"
                                // onClick={() => setAttemptingSubmit(true)}
                              >
                                {t('newAllowComponent.label21')}
                              </Button>
                            </div>
                          </div>
                        </Form>
                      </div>
                    }
                    maxWidth="1200px"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const AllowanceRoutes = ({
  classes,
  control,
  getValues,
  calculateDistance
}) => {
  const { fields, append, remove } = useFieldArray({
    name: 'startPlace',
    control
  })
  const { fields: endPlaceField } = useFieldArray({
    name: 'endPlace',
    control
  })

  function handleRemove(index) {
    remove(index)
  }

  function handleAdd() {
    append({ route: '' })
  }

  function handleCalculateDistance() {
    const formValues = getValues()
    calculateDistance(formValues)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="row" style={{ padding: '15px' }}>
            <div>
              {generateRouteStops(
                control,
                classes,
                fields,
                handleRemove,
                handleAdd
              )}
              <div
                className="col-xs-12 col-sm-12 col-md-3 col-lg-2"
                style={{ marginRight: '50px' }}
              >
                <div
                  style={{
                    marginTop: '21px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={handleAdd}
                  >
                    {t('newAllowComponent.label10')}
                  </Button>
                </div>
              </div>
              {fields.length > 1 || mobileView ? (
                <div className="row" style={{ padding: '15px' }}></div>
              ) : null}
              {generateEndPlace(t, control, classes, endPlaceField, handleAdd)}
              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <div style={{ marginTop: '21px' }}>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleCalculateDistance}
                  >
                    {t('newAllowComponent.calculateDist')}
                  </Button>
                </div>
              </div>
            </div>
            <div>
              <img
                className={classNames('pull-right', classes.googleLogo)}
                src={poweredByGoogle}
              />
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const generateRouteStops = (control, classes, fields, remove, handleAdd) => {
  return fields.map((field, index) => (
    <AllowanceRoute
      key={field.id}
      index={index}
      remove={remove}
      control={control}
      type={index === 0 ? 'start' : 'stop'}
      handleAdd={handleAdd}
      fields={fields}
      classes={classes}
    />
  ))
}

const AllowanceRoute = ({ index, classes, control, remove, type }) => {
  const label =
    type === 'start' ? 'newAllowRow.startLabel' : 'newAllowRow.middleLabel'
  return (
    <Translation>
      {(t) => {
        return (
          <div
            className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
            style={
              type === 'stop'
                ? {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingTop: mobileView ? '10px' : null
                  }
                : null
            }
          >
            <div
              style={{
                width: type !== 'stop' ? '100%' : '95%'
              }}
            >
              <Field
                name={`startPlace.${index}.route`}
                label={t(label)}
                placeholder={t(label)}
                inputType="autocomplete-places"
                control={control}
                className={
                  type === 'stop'
                    ? classNames(classes.textField, classes.resize)
                    : classNames(classes.textField2, classes.resize)
                }
              />
            </div>

            {type !== 'stop' ? null : (
              <IconButton
                aria-label="Delete"
                className={classes.margin}
                onClick={() => remove(index)}
                key={index}
                style={{
                  margin: '20px 3px 8px 3px',
                  padding: '12px 0px 12px 0px'
                }}
              >
                <FontAwesome
                  name="window-close"
                  style={{
                    width: '100%',
                    color: '#F67131'
                  }}
                />
              </IconButton>
            )}
          </div>
        )
      }}
    </Translation>
  )
}

const generateEndPlace = (t, control, classes, endPlaceField) => {
  return endPlaceField.map((el, index) => (
    <div
      key={el.id}
      className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
      style={{
        paddingRight: '14px'
      }}
    >
      <Field
        name={`endPlace.${index}.route`}
        label={t('newAllowRow.endLabel')}
        placeholder={t('newAllowRow.endLabel')}
        inputType="autocomplete-places"
        control={control}
        className={classNames(classes.textField2, classes.resize)}
      />
    </div>
  ))
}

AddAllowanceComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AddAllowanceComponent)
